export default {
  site_title: "Kakobuy Spreadsheet Polska – Najlepszy Spreadsheet do Zakupów z Chin 2026",
  site_description: "Odkryj najlepszy Kakobuy Spreadsheet 2026. Poradniki zakupowe, porównania platform, listy produktów i bezpieczne zakupy z Chin przez Kakobuy. Sprawdź nasz spreadsheet!",
  hero_tag: "Kakobuy Spreadsheet 2026",
  hero_title_1: "Najlepszy Spreadsheet",
  hero_title_2: "do Zakupów z Chin",
  hero_subtitle: "Kompletny przewodnik po zakupach przez Kakobuy. Znajdź najlepsze produkty, porównaj ceny i zamawiaj bezpiecznie.",
  btn_spreadsheet: "Kakobuy Spreadsheet",
  btn_buy_now: "Kup Teraz",
  nav_home: "Strona Główna",
  nav_categories: "Kategorie",
  nav_guides: "Przewodnik Zakupowy",
  nav_blog: "Artykuły",
  nav_comparison: "Porównania",
  dropdown_all: "Wszystkie kategorie",
  section_categories_title: "Popularne Kategorie",
  section_categories_sub: "Przeglądaj nasze kategorie produktów",
  section_categories_heading: "Przeglądaj wszystkie kategorie Kakobuy",
  section_categories_desc: "Znajdź najlepsze produkty w każdej kategorii",
  section_article_title: "Artykuły SEO",
  section_article_heading: "Artykuły i Poradniki Kakobuy",
  section_article_desc: "Poznaj nasze szczegółowe artykuły i poradniki. Od porównań platform, przez tutoriale zakupowe, po przewodniki bezpieczeństwa – wszystko, czego potrzebujesz, aby robić najlepsze zakupy z Chin.",
  section_article_cta: "Przeczytaj pełny poradnik",
  section_article_latest: "Najnowsze artykuły",
  section_cta_title: "Gotowy na zakupy?",
  section_cta_desc: "Odkryj tysiące produktów w naszym spreadsheetzie. Najlepsza jakość, najlepsze ceny.",
  section_testimonials_title: "Zaufanie Użytkowników",
  section_testimonials_sub: "Opinie",
  section_articles_grid_title: "Nasze Artykuły SEO",
  section_articles_grid_sub: "Poznaj nasze przewodniki",
  footer_brand: "Kakobuy",
  footer_description: "Twój najlepszy przewodnik po zakupach z Chin przez Kakobuy. Sprawdzone produkty, bezpieczne zamówienia i szybka dostawa do Polski.",
  footer_copyright: "© 2026 Kakobuy Spreadsheet. Wszelkie prawa zastrzeżone.",
  footer_newsletter_title: "Zapisz się do newslettera",
  footer_newsletter_desc: "Otrzymuj najlepsze oferty i poradniki",
  footer_newsletter_btn: "Zapisz się",
  footer_links_categories: "Kategorie",
  footer_links_guides: "Poradniki",
  footer_links_company: "Firma",
  breadcrumb_home: "Strona główna",
  read_more: "Czytaj więcej",
  all_categories: "Wszystkie kategorie",
  search_placeholder: "Szukaj...",
};